export * from './lazy-image.module';
export * from './lazy-image.directive';
